(function () {
  'use strict';

  var config = window.HENGE_CLEAR_ANALYTICS_CONFIG || {};
  var endpoint = String(config.endpoint || '').trim();
  var path = normalizePath(window.location.pathname);
  if (['/pages/clearlp', '/pages/henge-clear', '/pages/thanks'].indexOf(path) < 0) return;

  var SCHEMA = 'CLEAR_202609_V2';
  var TRACKER = String(config.trackerVersion || 'CLEAR_WEB_02');
  var ENVIRONMENT = String(config.environment || '');
  if (ENVIRONMENT !== 'production' && ENVIRONMENT !== 'test') return;
  var CAMPAIGN = 'CLEAR_202609';
  var MAX_SESSION_SENDS = 2;
  var SESSION_TTL = 30 * 60 * 1000;
  var APPLICATION_TTL = 2 * 60 * 60 * 1000;
  var PENDING_TTL = 24 * 60 * 60 * 1000;
  var MAX_PENDING_ATTEMPTS = 9;
  var ACTIVE_WINDOW = 30 * 1000;
  var SECTION_DELAY = 700;
  var KEYS = {
    visitor: environmentKey('henge_clear_202609_visitor'),
    session: environmentKey('henge_clear_202609_session'),
    state: environmentKey('henge_clear_202609_state'),
    first: environmentKey('henge_clear_202609_first_touch'),
    last: environmentKey('henge_clear_202609_last_touch'),
    application: environmentKey('henge_clear_202609_application'),
    applicationTab: environmentKey('henge_clear_202609_application_tab'),
    applicationDone: environmentKey('henge_clear_202609_application_done'),
    applicationPending: environmentKey('henge_clear_202609_application_pending'),
    headerJourney: environmentKey('henge_clear_header_journey'),
    applicationAttribution: environmentKey('henge_clear_202609_last_application_attribution'),
    pending: environmentKey('henge_clear_202609_pending_payload')
  };

  var experimentContext = readExperimentContext();
  if (experimentContext.redirect) {
    window.location.replace('/pages/clear-ab' + window.location.search + window.location.hash);
    return;
  }
  var pendingApplication = path === '/pages/thanks' ? readJson(sessionGet(KEYS.applicationTab), null) || readJson(localGet(KEYS.application), null) : null;
  var sourceLp = path === '/pages/henge-clear' ? 'henge-clear' :
    (path === '/pages/thanks' && pendingApplication && pendingApplication.source_lp === 'henge-clear' ? 'henge-clear' : 'clearlp');
  var payloadExperiment = validateExperimentContext(path === '/pages/thanks' && pendingApplication ? pendingApplication.experiment : experimentContext, sourceLp);
  var routerVisitReferrer = readRouterVisitReferrer();
  var trackingContextKey = String(path === '/pages/thanks' && pendingApplication && pendingApplication.experiment ?
    pendingApplication.experiment.experiment_id || 'direct' : experimentContext.experiment_id || 'direct') + '|' + sourceLp;
  var now = Date.now();
  var sessionInfo = readJson(sessionGet(KEYS.session), null);
  var sessionVisitorId = sessionInfo && validId(sessionInfo.visitor_id, 'cv_') ? sessionInfo.visitor_id : '';
  var storedVisitorId = localGet(KEYS.visitor) || sessionGet(KEYS.visitor) || getCookie(KEYS.visitor);
  var visitorId = sessionVisitorId || (validId(storedVisitorId, 'cv_') ? storedVisitorId : id('cv_'));
  localSet(KEYS.visitor, visitorId);
  sessionSet(KEYS.visitor, visitorId);
  setCookie(KEYS.visitor, visitorId, 31536000);
  if (!sessionInfo || !validId(sessionInfo.id, 'cs_') || now - Number(sessionInfo.touched_at || 0) > SESSION_TTL) {
    sessionInfo = { id: id('cs_'), visitor_id: visitorId, landing_at: new Date().toISOString(), touched_at: now };
    sessionSet(KEYS.state, '');
  }
  sessionInfo.visitor_id = visitorId;
  sessionInfo.touched_at = now;
  sessionSet(KEYS.session, JSON.stringify(sessionInfo));

  var current = readAttribution();
  updateTouches(current);
  var metaAtLanding = readMetaIdentifiers(current.fbclid);
  loadCustomerPrivacy(function () { metaAtLanding = readMetaIdentifiers(current.fbclid); });
  var state = restoreState();
  var activeLastTick = performance.now();
  var lastInteraction = Date.now();
  var scrollQueued = false;
  var sectionObservers = [];
  var formObservers = [];

  function normalizePath(value) { var out = String(value || '/').replace(/\/+$/, ''); return out || '/'; }
  function environmentKey(value) { return ENVIRONMENT === 'test' ? 'henge_test_' + value : value; }
  function storageGet(storage, key) { try { return storage.getItem(key); } catch (e) { return null; } }
  function storageSet(storage, key, value) { try { storage.setItem(key, value); return true; } catch (e) { return false; } }
  function storageRemove(storage, key) { try { storage.removeItem(key); } catch (e) {} }
  function localGet(key) { return storageGet(window.localStorage, key); }
  function localSet(key, value) { return storageSet(window.localStorage, key, value); }
  function sessionGet(key) { return storageGet(window.sessionStorage, key); }
  function sessionSet(key, value) { return storageSet(window.sessionStorage, key, value); }
  function readJson(value, fallback) { try { return value ? JSON.parse(value) : fallback; } catch (e) { return fallback; } }
  function getCookie(name) {
    try {
      var parts = document.cookie ? document.cookie.split('; ') : [];
      for (var i = 0; i < parts.length; i++) {
        var pair = parts[i].split('=');
        if (decodeURIComponent(pair.shift() || '') === name) return decodeURIComponent(pair.join('='));
      }
    } catch (e) {}
    return '';
  }
  function marketingAllowed() {
    try { return Boolean(window.Shopify && window.Shopify.customerPrivacy &&
      window.Shopify.customerPrivacy.marketingAllowed()); } catch (e) { return false; }
  }
  function loadCustomerPrivacy(onReady) {
    if (!window.Shopify || window.Shopify.customerPrivacy || typeof window.Shopify.loadFeatures !== 'function') return;
    try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error) onReady();
    }); } catch (e) {}
  }
  function readMetaIdentifiers(fbclid) {
    var result = { allowed: marketingAllowed(), fbp: '', fbc: '', fbclid: '' };
    if (!result.allowed) return result;
    var fbp = getCookie('_fbp');
    var fbc = getCookie('_fbc');
    result.fbp = /^fb\.\d+\.\d{10,13}\.[^\s;]{1,300}$/.test(fbp) ? fbp.slice(0, 400) : '';
    result.fbc = /^fb\.\d+\.\d{10,13}\.[^\s;]{1,300}$/.test(fbc) ? fbc.slice(0, 400) : '';
    result.fbclid = /^[A-Za-z0-9._-]{1,300}$/.test(String(fbclid || '')) ? String(fbclid) : '';
    if (!result.fbc && result.fbclid) result.fbc = 'fb.1.' + Date.now() + '.' + result.fbclid;
    return result;
  }
  function applicationMetaIdentifiers(saved) {
    var currentMeta = readMetaIdentifiers('');
    if (!currentMeta.allowed) return { fbp: '', fbc: '' };
    return { fbp: saved && saved.fbp || currentMeta.fbp, fbc: saved && saved.fbc || currentMeta.fbc };
  }
  function setCookie(name, value, maxAge) {
    try { document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + '; path=/; max-age=' + Number(maxAge || 0) + '; samesite=lax'; } catch (e) {}
  }
  function readExperimentContext() {
    var activeId = String(config.experimentId || '');
    var context = { experiment_id: '', experiment_variant: '', experiment_assigned_at: '', experiment_enrolled: false,
      experiment_entry_url: '', experiment_entry_referrer: '' };
    if (!/^CLEAR_202609_EXP[0-9]+$/.test(activeId) || path === '/pages/thanks') return context;
    var expected = path === '/pages/clearlp' ? 'A' : 'B';
    var entry = readJson(sessionGet(environmentKey('henge_clear_ab_entry')), null);
    var forced = '';
    try { forced = String(new URLSearchParams(window.location.search || '').get('ab') || '').toUpperCase(); } catch (e) {}
    if (forced === 'A' || forced === 'B') {
      if (entry && entry.experiment_id === activeId && entry.experiment_variant === expected && entry.experiment_enrolled === false) return entry;
      return context;
    }
    var key = environmentKey('henge_clear_ab_' + activeId);
    var localAssignment = readJson(localGet(key), null);
    var cookieAssignment = readJson(getCookie(key), null);
    function validAssignment(value) {
      return value && (value.variant === 'a' || value.variant === 'b') &&
        typeof value.assigned_at === 'string' && value.assigned_at && !isNaN(Date.parse(value.assigned_at));
    }
    var assignment = validAssignment(localAssignment) ? localAssignment : (validAssignment(cookieAssignment) ? cookieAssignment : null);
    var previousKey = environmentKey('henge_clear_ab_last_experiment');
    if (assignment && (assignment.variant === 'a' || assignment.variant === 'b')) {
      if (assignment.variant.toUpperCase() !== expected) return { redirect: true };
      context.experiment_id = activeId;
      context.experiment_variant = expected;
      context.experiment_assigned_at = assignment.assigned_at || '';
      context.experiment_enrolled = true;
      context.experiment_entry_url = assignment.entry_url || '';
      context.experiment_entry_referrer = assignment.entry_referrer || '';
      return context;
    }
    if (entry && entry.experiment_id === activeId && entry.experiment_variant === expected &&
        entry.experiment_enrolled === true && typeof entry.experiment_assigned_at === 'string' &&
        entry.experiment_assigned_at && !isNaN(Date.parse(entry.experiment_assigned_at))) return entry;
    assignment = {
      variant: localAssignment && (localAssignment.variant === 'a' || localAssignment.variant === 'b') ? localAssignment.variant :
        (cookieAssignment && (cookieAssignment.variant === 'a' || cookieAssignment.variant === 'b') ? cookieAssignment.variant :
          (Math.random() < 0.5 ? 'a' : 'b')),
      assigned_at: new Date().toISOString(),
      entry_url: cleanUrl(window.location.href),
      entry_referrer: document.referrer ? cleanUrl(document.referrer) : ''
    };
    var serialized = JSON.stringify(assignment);
    localSet(key, serialized);
    setCookie(key, serialized, 31536000);
    localSet(previousKey, activeId);
    setCookie(previousKey, activeId, 31536000);
    localAssignment = readJson(localGet(key), null);
    cookieAssignment = readJson(getCookie(key), null);
    var stored = validAssignment(localAssignment) && localAssignment.variant === assignment.variant ? localAssignment :
      (validAssignment(cookieAssignment) && cookieAssignment.variant === assignment.variant ? cookieAssignment : null);
    var storedPreviousId = localGet(previousKey) || getCookie(previousKey);
    if (!stored || storedPreviousId !== activeId || stored.assigned_at !== assignment.assigned_at) return context;
    if (stored.variant.toUpperCase() !== expected) return { redirect: true };
    context.experiment_id = activeId;
    context.experiment_variant = expected;
    context.experiment_assigned_at = stored.assigned_at;
    context.experiment_enrolled = true;
    context.experiment_entry_url = stored.entry_url || '';
    context.experiment_entry_referrer = stored.entry_referrer || '';
    return context;
  }
  function readRouterVisitReferrer() {
    if (path === '/pages/thanks') return null;
    var key = environmentKey('henge_clear_ab_visit_referrer');
    var visit = readJson(sessionGet(key), null);
    storageRemove(window.sessionStorage, key);
    var expected = path === '/pages/clearlp' ? 'A' : 'B';
    if (!visit || visit.experiment_id !== config.experimentId || visit.experiment_variant !== expected ||
        typeof visit.referrer !== 'string' || !isFinite(Number(visit.created_at)) ||
        Math.abs(Date.now() - Number(visit.created_at)) > 60000) return null;
    return visit.referrer;
  }
  function validateExperimentContext(value, lp) {
    var result = { experiment_id: '', experiment_variant: '', experiment_assigned_at: '', experiment_enrolled: false };
    if (!value || value.experiment_enrolled !== true) return result;
    var expected = lp === 'henge-clear' ? 'B' : 'A';
    if (!/^CLEAR_202609_EXP[0-9]+$/.test(value.experiment_id || '') ||
        value.experiment_variant !== expected ||
        typeof value.experiment_assigned_at !== 'string' ||
        !value.experiment_assigned_at || isNaN(Date.parse(value.experiment_assigned_at))) {
      if (window.console && typeof window.console.warn === 'function') {
        window.console.warn('HENGE CLEAR analytics: invalid experiment context; sending as non-enrolled.');
      }
      return result;
    }
    result.experiment_id = value.experiment_id;
    result.experiment_variant = expected;
    result.experiment_assigned_at = value.experiment_assigned_at;
    result.experiment_enrolled = true;
    return result;
  }
  function id(prefix) {
    if (window.crypto && window.crypto.randomUUID) return prefix + window.crypto.randomUUID();
    return prefix + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
  }
  function validId(value, prefix) { return typeof value === 'string' && value.indexOf(prefix) === 0 && value.length <= 84; }
  function clean(value, max) { return String(value || '').replace(/[<>\u0000-\u001f\u007f]/g, '').trim().slice(0, max || 180); }
  function cleanUrl(value) { try { var u = new URL(String(value || ''), window.location.origin); return (u.origin + normalizePath(u.pathname)).slice(0, 500); } catch (e) { return ''; } }
  function param(params, primary, alias) { return clean(params.get(primary) || (alias ? params.get(alias) : ''), 300); }

  function readAttribution() {
    var params;
    try { params = new URLSearchParams(window.location.search || ''); } catch (e) { params = { get: function () { return ''; } }; }
    return {
      timestamp: new Date().toISOString(),
      utm_source: param(params, 'utm_source'), utm_medium: param(params, 'utm_medium'),
      utm_campaign: param(params, 'utm_campaign'), utm_content: param(params, 'utm_content'), utm_term: param(params, 'utm_term'),
      meta_campaign_id: param(params, 'meta_campaign_id', 'campaign_id'),
      meta_adset_id: param(params, 'meta_adset_id', 'adset_id'),
      meta_ad_id: param(params, 'meta_ad_id', 'ad_id'), creative_code: param(params, 'creative_code'),
      meta_platform: param(params, 'meta_platform'),
      meta_placement: param(params, 'meta_placement'),
      fbclid: param(params, 'fbclid'), landing_url: cleanUrl(window.location.href)
    };
  }

  function isMetaTouch(t) {
    return Boolean(t.meta_campaign_id || t.meta_adset_id || t.meta_ad_id || t.fbclid || /^(meta|facebook|instagram|fb)$/i.test(t.utm_source));
  }

  function updateTouches(t) {
    if (!isMetaTouch(t)) return;
    if (!readTouch(KEYS.first)) writeTouch(KEYS.first, t);
    writeTouch(KEYS.last, t);
  }

  function readTouch(key) {
    return readJson(localGet(key), null) || readJson(sessionGet(key), null) || readJson(getCookie(key), null);
  }

  function writeTouch(key, value) {
    var serialized = JSON.stringify(value);
    localSet(key, serialized);
    sessionSet(key, serialized);
    setCookie(key, serialized, 7776000);
  }

  function completedApplicationTouches() {
    var first = readTouch(KEYS.first) || {};
    var last = readTouch(KEYS.last) || {};
    if (!isMetaTouch(current)) return { first: first, last: last };
    var keys = ['timestamp', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
      'meta_campaign_id', 'meta_adset_id', 'meta_ad_id', 'creative_code',
      'meta_platform', 'meta_placement', 'fbclid', 'landing_url'];
    function fillMissing(existing) {
      var result = {};
      keys.forEach(function (key) { result[key] = existing[key] || current[key] || ''; });
      return result;
    }
    return { first: fillMissing(first), last: fillMissing(last) };
  }

  function emptyState(startedAt) {
    return {
      tracking_context_key: trackingContextKey,
      started_at: startedAt || sessionInfo.landing_at, last_seen_at: new Date().toISOString(),
      active_seconds: 0, total_seconds: 0, max_scroll_percent: 0,
      sections_reached: {}, section_first_reached: {}, section_dwell: {},
      form_view: false, form_start: false, cta_click_count: 0,
      cta_inline_click_count: 0, cta_sticky_click_count: 0,
      cta_first_type: '', cta_last_type: '',
      application_success: false, snapshot_sequence: 0, snapshot_send_count: 0,
      success_snapshot_sent: false, checkpoint_sent: false, dirty: true
    };
  }

  function restoreState() {
    var saved = readJson(sessionGet(KEYS.state), null);
    if (!saved || saved.session_id !== sessionInfo.id || saved.tracking_context_key !== trackingContextKey) {
      saved = emptyState(saved && saved.session_id === sessionInfo.id ? new Date().toISOString() : sessionInfo.landing_at);
    }
    saved.session_id = sessionInfo.id;
    saved.sections_reached = saved.sections_reached || {};
    saved.section_first_reached = saved.section_first_reached || {};
    saved.section_dwell = saved.section_dwell || {};
    saved.cta_inline_click_count = Number(saved.cta_inline_click_count || 0);
    saved.cta_sticky_click_count = Number(saved.cta_sticky_click_count || 0);
    saved.cta_first_type = saved.cta_first_type === 'inline' || saved.cta_first_type === 'sticky' ? saved.cta_first_type : '';
    saved.cta_last_type = saved.cta_last_type === 'inline' || saved.cta_last_type === 'sticky' ? saved.cta_last_type : '';
    return saved;
  }

  function persist() {
    state.last_seen_at = new Date().toISOString();
    sessionInfo.touched_at = Date.now();
    sessionSet(KEYS.session, JSON.stringify(sessionInfo));
    sessionSet(KEYS.state, JSON.stringify(state));
  }

  function deviceType() {
    var w = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    return w < 768 ? 'mobile' : (w < 1024 ? 'tablet' : 'desktop');
  }

  function scrollPercent() {
    var root = document.documentElement;
    var max = Math.max(root.scrollHeight - window.innerHeight, 1);
    return Math.max(0, Math.min(100, Math.round((window.scrollY || root.scrollTop || 0) / max * 1000) / 10));
  }

  function tickTime() {
    var p = performance.now();
    var delta = Math.max(0, Math.min(5, (p - activeLastTick) / 1000));
    activeLastTick = p;
    state.total_seconds = Math.max(0, Math.round((Date.now() - new Date(state.started_at).getTime()) / 100) / 10);
    if (document.visibilityState === 'visible' && Date.now() - lastInteraction <= ACTIVE_WINDOW) {
      state.active_seconds = Math.round((Number(state.active_seconds || 0) + delta) * 10) / 10;
      Object.keys(state._visible_sections || {}).forEach(function (section) {
        state.section_dwell[section] = Math.round((Number(state.section_dwell[section] || 0) + delta) * 10) / 10;
      });
    }
    state.dirty = true;
    persist();
    if (!state.checkpoint_sent && state.active_seconds >= 30) {
      state.checkpoint_sent = true;
      sendSnapshot('meaningful_30s', false);
    }
  }

  function touchInteraction(event) {
    if (!event || event.isTrusted) lastInteraction = Date.now();
  }

  function updateScroll() {
    scrollQueued = false;
    var next = scrollPercent();
    if (next > state.max_scroll_percent) { state.max_scroll_percent = next; state.dirty = true; persist(); }
  }

  function sectionName(element) {
    var idValue = element.id || '';
    if (/henge_hero_carousel/.test(idValue)) return 'hero';
    if (/advanced_content_7ThdU9|lottery_status_box/.test(idValue)) return 'lottery_overview';
    if (/lottery_form/.test(idValue) || element.querySelector('.clear-lottery-form-section')) return 'form_top';
    if (/henge_flexible_section_gGyPfT/.test(idValue)) return 'taste';
    if (/henge_flexible_section_xgdUBk/.test(idValue)) return 'achievement';
    if (/advanced_content_ULbtmd|sommelier/.test(idValue)) return 'sommelier';
    if (/customer_voice_gallery/.test(idValue)) return 'customer_voice';
    if (/henge_carousel/.test(idValue)) return 'production_process';
    if (/c_faq/.test(idValue)) return 'faq';
    return '';
  }

  function rendered(element) {
    if (!element || !element.getClientRects().length) return false;
    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function initSections() {
    state._visible_sections = {};
    if (!window.IntersectionObserver) return;
    Array.prototype.forEach.call(document.querySelectorAll('#MainContent > .shopify-section'), function (element) {
      var name = sectionName(element);
      if (!name || !rendered(element)) return;
      var timer = 0;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
            if (timer || state.sections_reached[name]) { if (state.sections_reached[name]) state._visible_sections[name] = true; return; }
            timer = window.setTimeout(function () {
              timer = 0;
              state.sections_reached[name] = 1;
              state.section_first_reached[name] = state.section_first_reached[name] || new Date().toISOString();
              state._visible_sections[name] = true;
              state.dirty = true;
              persist();
            }, SECTION_DELAY);
          } else {
            if (timer) { window.clearTimeout(timer); timer = 0; }
            delete state._visible_sections[name];
          }
        });
      }, { threshold: [0, 0.25, 0.5] });
      observer.observe(element);
      sectionObservers.push(observer);
    });
  }

  function isLotteryForm(form) {
    return Boolean(form && form.closest('.clear-lottery-form-section') && form.querySelector('input[name="return_to"][value="/pages/thanks"]'));
  }

  function emailHash(form) {
    var input = form.querySelector('input[type="email"], input[name="contact[email]"]');
    var normalized = input ? String(input.value || '').trim().toLowerCase() : '';
    return normalized ? sha256(normalized) : '';
  }

  function initForms() {
    var forms = Array.prototype.filter.call(document.querySelectorAll('.clear-lottery-form-section form'), function (form) { return isLotteryForm(form) && rendered(form); });
    forms.forEach(function (form, index) {
      var placement = index === 0 ? 'top' : 'bottom';
      form.setAttribute('data-henge-clear-form-position', placement);
      var started = false;
      function markStart(event) { if (event && !event.isTrusted || started) return; started = true; state.form_start = true; state.dirty = true; persist(); }
      form.addEventListener('focusin', markStart, true);
      form.addEventListener('input', markStart, true);
      form.addEventListener('submit', function () {
        if (form.checkValidity && !form.checkValidity()) return;
        var applicationTouches = completedApplicationTouches();
        var metaAtSubmit = readMetaIdentifiers(current.fbclid);
        if (metaAtSubmit.allowed && !getCookie('_fbc') && metaAtLanding.allowed &&
            metaAtLanding.fbclid === metaAtSubmit.fbclid && metaAtLanding.fbc) metaAtSubmit.fbc = metaAtLanding.fbc;
        var application = {
          application_id: id('ca_'), application_at: new Date().toISOString(), expires_at: Date.now() + APPLICATION_TTL,
          customer_key: emailHash(form), form_placement: placement,
          source_lp: sourceLp, experiment: payloadExperiment,
          first_touch: applicationTouches.first, last_touch: applicationTouches.last,
          meta_identifiers: { fbp: metaAtSubmit.fbp, fbc: metaAtSubmit.fbc },
          referrer: routerVisitReferrer !== null ? (routerVisitReferrer ? cleanUrl(routerVisitReferrer) : '') :
            (document.referrer ? cleanUrl(document.referrer) : ''),
          attribution: {
            utm_source: current.utm_source, utm_medium: current.utm_medium,
            utm_campaign: current.utm_campaign, utm_content: current.utm_content, utm_term: current.utm_term,
            fbclid: current.fbclid, meta_campaign_id: current.meta_campaign_id,
            meta_adset_id: current.meta_adset_id, meta_ad_id: current.meta_ad_id, creative_code: current.creative_code,
            meta_platform: current.meta_platform, meta_placement: current.meta_placement
          }
        };
        sessionSet(KEYS.applicationTab, JSON.stringify(application));
        localSet(KEYS.application, JSON.stringify(application));
        state.dirty = true;
        persist();
      }, true);
      if (!window.IntersectionObserver) return;
      var timer = 0;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.3) {
            if (!timer && !state.form_view) timer = window.setTimeout(function () { timer = 0; state.form_view = true; state.dirty = true; persist(); }, 500);
          } else if (timer) { window.clearTimeout(timer); timer = 0; }
        });
      }, { threshold: [0, 0.3] });
      observer.observe(form);
      formObservers.push(observer);
    });
  }

  function initCtas() {
    document.addEventListener('click', function (event) {
      var target = event.target.closest && event.target.closest('[data-henge-analytics-cta], [data-henge-cta-type], .clear-lottery-form-section button[type="submit"], .clear-lottery-form-section input[type="submit"]');
      if (!target || !event.isTrusted) return;
      var form = target.closest && target.closest('form');
      if (form && !isLotteryForm(form)) return;
      var ctaType = target.getAttribute('data-henge-cta-type');
      state.cta_click_count = Number(state.cta_click_count || 0) + 1;
      if (ctaType === 'inline' || ctaType === 'sticky') {
        if (ctaType === 'inline') state.cta_inline_click_count = Number(state.cta_inline_click_count || 0) + 1;
        if (ctaType === 'sticky') state.cta_sticky_click_count = Number(state.cta_sticky_click_count || 0) + 1;
        if (!state.cta_first_type) state.cta_first_type = ctaType;
        state.cta_last_type = ctaType;
      }
      state.dirty = true;
      persist();
    }, true);
  }

  function basePayload() {
    tickTime();
    var first = readTouch(KEYS.first) || {};
    var last = readTouch(KEYS.last) || {};
    return {
      schema_version: SCHEMA, tracker_version: TRACKER, environment: ENVIRONMENT,
      experiment_id: payloadExperiment.experiment_id, experiment_variant: payloadExperiment.experiment_variant,
      experiment_assigned_at: payloadExperiment.experiment_assigned_at, experiment_enrolled: payloadExperiment.experiment_enrolled,
      campaign_id: CAMPAIGN, lottery_type: 'CLEAR', session_id: sessionInfo.id, visitor_id: visitorId,
      page_path: path, page_url: cleanUrl(window.location.href), lp_variant: sourceLp,
      landing_at: state.started_at, last_seen_at: state.last_seen_at,
      device_type: deviceType(), viewport_width: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
      referrer: routerVisitReferrer !== null ? (routerVisitReferrer ? cleanUrl(routerVisitReferrer) : '') :
        (document.referrer ? cleanUrl(document.referrer) : ''),
      utm_source: current.utm_source, utm_medium: current.utm_medium, utm_campaign: current.utm_campaign,
      utm_content: current.utm_content, utm_term: current.utm_term, fbclid: current.fbclid,
      meta_campaign_id: current.meta_campaign_id, meta_adset_id: current.meta_adset_id,
      meta_ad_id: current.meta_ad_id, creative_code: current.creative_code,
      meta_platform: current.meta_platform, meta_placement: current.meta_placement,
      touch: { first: first, last: last },
      active_seconds: state.active_seconds, total_seconds: state.total_seconds,
      max_scroll_percent: state.max_scroll_percent,
      sections_reached: state.sections_reached, section_first_reached: state.section_first_reached,
      section_dwell: state.section_dwell, form_view: state.form_view, form_start: state.form_start,
      cta_click_count: state.cta_click_count,
      cta_inline_click_count: state.cta_inline_click_count,
      cta_sticky_click_count: state.cta_sticky_click_count,
      cta_first_type: state.cta_first_type, cta_last_type: state.cta_last_type,
      application_success: state.application_success
    };
  }

  function pendingEventId(payload) { return clean(payload && (payload.snapshot_id || payload.application_id), 84); }
  function removePending(eventId) {
    var stored = readJson(localGet(KEYS.pending), null);
    if (!stored || stored.event_id === eventId || pendingEventId(stored) === eventId) storageRemove(window.localStorage, KEYS.pending);
  }
  function transmit(payload, preferBeacon, existingPending) {
    if (!endpoint) return false;
    var body = JSON.stringify(payload);
    var eventId = pendingEventId(payload);
    if (!eventId) return false;
    var pending = existingPending && existingPending.event_id === eventId ? existingPending : {
      event_id: eventId,
      created_at: new Date().toISOString(),
      retry_count: 0,
      environment: ENVIRONMENT,
      event_type: payload.kind,
      payload: payload
    };
    var createdAt = Date.parse(pending.created_at || '');
    if (!isFinite(createdAt) || Date.now() - createdAt > PENDING_TTL || Number(pending.retry_count || 0) >= MAX_PENDING_ATTEMPTS || pending.environment !== ENVIRONMENT) {
      removePending(eventId);
      return false;
    }
    localSet(KEYS.pending, JSON.stringify(pending));
    function attempt(number) {
      var currentPending = readJson(localGet(KEYS.pending), null);
      var currentEventId = currentPending && (currentPending.event_id || pendingEventId(currentPending));
      if (currentEventId && currentEventId !== eventId) return;
      if (Number(pending.retry_count || 0) >= MAX_PENDING_ATTEMPTS || Date.now() - createdAt > PENDING_TTL) {
        removePending(eventId);
        return;
      }
      pending.retry_count = Number(pending.retry_count || 0) + 1;
      localSet(KEYS.pending, JSON.stringify(pending));
      try {
        window.fetch(endpoint, { method: 'POST', mode: 'cors', credentials: 'omit', keepalive: Boolean(preferBeacon), headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: body })
          .then(function (response) { if (!response.ok) throw new Error('SESSION_HTTP_ERROR'); return response.json(); })
          .then(function (result) {
            var expectedId = payload.snapshot_id || payload.application_id || '';
            if (result && result.ok === true && result.kind === payload.kind && result.id === expectedId) {
              removePending(eventId);
              return;
            }
            if (result && (result.retryable === true || result.error === 'LOCK_TIMEOUT') && number < 3) window.setTimeout(function () { attempt(number + 1); }, 300 * Math.pow(2, number - 1));
            else if (result && result.retryable !== true && result.error !== 'LOCK_TIMEOUT') removePending(eventId);
          })
          .catch(function () { if (number < 3) window.setTimeout(function () { attempt(number + 1); }, 300 * Math.pow(2, number - 1)); });
      } catch (e) {
        if (number < 3) window.setTimeout(function () { attempt(number + 1); }, 300 * Math.pow(2, number - 1));
      }
    }
    attempt(1);
    return true;
  }

  function sendSnapshot(reason, beacon) {
    if (!state.dirty || state.snapshot_send_count >= MAX_SESSION_SENDS || path === '/pages/thanks') return false;
    state.snapshot_sequence = Number(state.snapshot_sequence || 0) + 1;
    state.snapshot_send_count = Number(state.snapshot_send_count || 0) + 1;
    var payload = basePayload();
    payload.kind = 'session_snapshot';
    payload.snapshot_id = id('css_');
    payload.snapshot_reason = reason;
    payload.snapshot_sequence = state.snapshot_sequence;
    state.dirty = false;
    persist();
    return transmit(payload, beacon);
  }

  function sendSuccessSnapshot(app) {
    if (path !== '/pages/thanks' || state.success_snapshot_sent || !state.application_success) return false;
    var payload = basePayload();
    payload.kind = 'session_snapshot';
    payload.snapshot_id = id('css_');
    payload.snapshot_reason = 'application_success';
    payload.snapshot_sequence = Number(state.snapshot_sequence || 0) + 1;
    payload.page_path = '/pages/' + (app.source_lp === 'henge-clear' ? 'henge-clear' : 'clearlp');
    payload.page_url = window.location.origin + payload.page_path;
    payload.lp_variant = app.source_lp === 'henge-clear' ? 'henge-clear' : 'clearlp';
    payload.referrer = app.referrer || '';
    if (app.attribution && typeof app.attribution === 'object') {
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid',
        'meta_campaign_id', 'meta_adset_id', 'meta_ad_id', 'creative_code',
        'meta_platform', 'meta_placement'].forEach(function (key) {
        payload[key] = app.attribution[key] || '';
      });
    }
    payload.touch = { first: app.first_touch || payload.touch.first, last: app.last_touch || payload.touch.last };
    if (!transmit(payload, true)) return false;
    state.snapshot_sequence = payload.snapshot_sequence;
    state.snapshot_send_count = Number(state.snapshot_send_count || 0) + 1;
    state.success_snapshot_sent = true;
    state.dirty = false;
    persist();
    return true;
  }

  function applicationPendingEnvelope(payload) {
    return { application_id: payload.application_id, created_at: new Date().toISOString(), retry_count: 0,
      environment: ENVIRONMENT, payload: payload };
  }
  function sendApplicationPayload(payload, app, pending) {
    if (!endpoint || !payload || !validId(payload.application_id, 'ca_')) return;
    pending = pending || applicationPendingEnvelope(payload);
    var createdAt = Date.parse(pending.created_at || '');
    if (!isFinite(createdAt) || Date.now() - createdAt > PENDING_TTL || Number(pending.retry_count || 0) >= MAX_PENDING_ATTEMPTS || pending.environment !== ENVIRONMENT) {
      storageRemove(window.localStorage, KEYS.applicationPending);
      return;
    }
    localSet(KEYS.applicationPending, JSON.stringify(pending));
    function sendAttempt(number) {
      var current = readJson(localGet(KEYS.applicationPending), null);
      if (current && current.application_id !== payload.application_id) return;
      if (Number(pending.retry_count || 0) >= MAX_PENDING_ATTEMPTS || Date.now() - createdAt > PENDING_TTL) {
        storageRemove(window.localStorage, KEYS.applicationPending);
        return;
      }
      var metaIdentifiers = applicationMetaIdentifiers({ fbp: payload.fbp, fbc: payload.fbc });
      payload.fbp = metaIdentifiers.fbp;
      payload.fbc = metaIdentifiers.fbc;
      pending.retry_count = Number(pending.retry_count || 0) + 1;
      localSet(KEYS.applicationPending, JSON.stringify(pending));
      window.fetch(endpoint, { method: 'POST', mode: 'cors', credentials: 'omit', keepalive: true,
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(payload) })
        .then(function (response) { if (!response.ok) throw new Error('APPLICATION_HTTP_ERROR'); return response.json(); })
        .then(function (result) {
          if (result && (result.retryable === true || result.error === 'LOCK_TIMEOUT') && number < 3) {
            window.setTimeout(function () { sendAttempt(number + 1); }, 300 * Math.pow(2, number - 1));
            return;
          }
          if (!result || result.ok !== true || result.kind !== 'application' || result.id !== payload.application_id) {
            if (result && result.retryable !== true && result.error !== 'LOCK_TIMEOUT') storageRemove(window.localStorage, KEYS.applicationPending);
            return;
          }
          storageRemove(window.localStorage, KEYS.applicationPending);
          localSet(KEYS.applicationDone, payload.application_id);
          storageRemove(window.sessionStorage, KEYS.applicationTab);
          storageRemove(window.localStorage, KEYS.application);
          storageRemove(window.localStorage, KEYS.headerJourney);
          if (path !== '/pages/thanks' || !app) return;
          state.application_success = true;
          state.dirty = true;
          persist();
          if (result.application_success_recorded === true) {
            state.success_snapshot_sent = true;
            state.dirty = false;
            persist();
          } else sendSuccessSnapshot(app);
        }).catch(function () { if (number < 3) window.setTimeout(function () { sendAttempt(number + 1); }, 300 * Math.pow(2, number - 1)); });
    }
    sendAttempt(1);
  }
  function resendPendingApplication() {
    var pending = readJson(localGet(KEYS.applicationPending), null);
    if (!pending) return false;
    var payload = pending.payload;
    if (!payload || pending.application_id !== payload.application_id || payload.kind !== 'application' ||
        pending.environment !== ENVIRONMENT || !validId(payload.application_id, 'ca_')) {
      storageRemove(window.localStorage, KEYS.applicationPending);
      return false;
    }
    sendApplicationPayload(payload, null, pending);
    return true;
  }
  function sendApplicationIfConfirmed() {
    if (path !== '/pages/thanks') return;
    var app = pendingApplication;
    if (!app || !validId(app.application_id, 'ca_') || Number(app.expires_at || 0) < Date.now()) return;
    if (localGet(KEYS.applicationDone) === app.application_id) {
      state.application_success = true;
      state.dirty = true;
      persist();
      if (state.success_snapshot_sent || sendSuccessSnapshot(app)) {
        storageRemove(window.sessionStorage, KEYS.applicationTab);
        storageRemove(window.localStorage, KEYS.application);
      }
      return;
    }
    var payload = basePayload();
    payload.application_success = true;
    payload.kind = 'application';
    payload.application_id = app.application_id;
    payload.application_at = app.application_at;
    payload.customer_key = app.customer_key;
    payload.form_placement = app.form_placement;
    payload.source_lp = app.source_lp === 'henge-clear' ? 'henge-clear' : 'clearlp';
    payload.lp_variant = payload.source_lp;
    payload.page_path = '/pages/' + payload.source_lp;
    if (app.attribution && typeof app.attribution === 'object') {
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid',
        'meta_campaign_id', 'meta_adset_id', 'meta_ad_id', 'creative_code',
        'meta_platform', 'meta_placement'].forEach(function (key) {
        payload[key] = app.attribution[key] || '';
      });
    }
    payload.touch = { first: app.first_touch || payload.touch.first, last: app.last_touch || payload.touch.last };
    var metaIdentifiers = applicationMetaIdentifiers(app.meta_identifiers);
    payload.fbp = metaIdentifiers.fbp;
    payload.fbc = metaIdentifiers.fbc;
    localSet(KEYS.applicationAttribution, JSON.stringify({ application_id: app.application_id, source_lp: payload.source_lp,
      experiment: app.experiment || null, customer_key: app.customer_key, application_at: app.application_at }));
    sendApplicationPayload(payload, app, applicationPendingEnvelope(payload));
  }

  function resendPending() {
    var stored = readJson(localGet(KEYS.pending), null);
    if (!stored || !endpoint) return;
    var pending = stored.payload ? stored : {
      event_id: pendingEventId(stored), created_at: new Date().toISOString(), retry_count: 0,
      environment: stored.environment, event_type: stored.kind, payload: stored
    };
    var payload = pending.payload;
    var createdAt = Date.parse(pending.created_at || '');
    if (!payload || (payload.schema_version !== SCHEMA && payload.schema_version !== 'CLEAR_202609_V1') ||
        pending.environment !== ENVIRONMENT || pending.event_type !== payload.kind || pending.event_id !== pendingEventId(payload) ||
        !isFinite(createdAt) || Date.now() - createdAt > PENDING_TTL || Number(pending.retry_count || 0) >= MAX_PENDING_ATTEMPTS) {
      storageRemove(window.localStorage, KEYS.pending);
      return;
    }
    if (payload.kind === 'application') return;
    transmit(payload, false, pending);
  }

  function sha256(ascii) {
    function rightRotate(value, amount) { return (value >>> amount) | (value << (32 - amount)); }
    var mathPow = Math.pow, maxWord = mathPow(2, 32), lengthProperty = 'length', i, j;
    var result = '', words = [], asciiBitLength = ascii[lengthProperty] * 8;
    var hash = sha256.h = sha256.h || [], k = sha256.k = sha256.k || [], primeCounter = k[lengthProperty], isComposite = {};
    for (var candidate = 2; primeCounter < 64; candidate++) { if (!isComposite[candidate]) { for (i = 0; i < 313; i += candidate) isComposite[i] = candidate; hash[primeCounter] = (mathPow(candidate, .5) * maxWord) | 0; k[primeCounter++] = (mathPow(candidate, 1 / 3) * maxWord) | 0; } }
    ascii += '\x80'; while (ascii[lengthProperty] % 64 - 56) ascii += '\x00';
    for (i = 0; i < ascii[lengthProperty]; i++) { j = ascii.charCodeAt(i); if (j >> 8) return ''; words[i >> 2] |= j << ((3 - i) % 4) * 8; }
    words[words[lengthProperty]] = ((asciiBitLength / maxWord) | 0); words[words[lengthProperty]] = (asciiBitLength);
    for (j = 0; j < words[lengthProperty];) { var w = words.slice(j, j += 16), oldHash = hash.slice(0); for (i = 0; i < 64; i++) { var w15 = w[i - 15], w2 = w[i - 2]; var a = hash[0], e = hash[4]; var temp1 = hash[7] + (rightRotate(e, 6) ^ rightRotate(e, 11) ^ rightRotate(e, 25)) + ((e & hash[5]) ^ ((~e) & hash[6])) + k[i] + (w[i] = (i < 16) ? w[i] : (w[i - 16] + (rightRotate(w15, 7) ^ rightRotate(w15, 18) ^ (w15 >>> 3)) + w[i - 7] + (rightRotate(w2, 17) ^ rightRotate(w2, 19) ^ (w2 >>> 10))) | 0); var temp2 = (rightRotate(a, 2) ^ rightRotate(a, 13) ^ rightRotate(a, 22)) + ((a & hash[1]) ^ (a & hash[2]) ^ (hash[1] & hash[2])); hash = [(temp1 + temp2) | 0].concat(hash); hash[4] = (hash[4] + temp1) | 0; hash.pop(); } for (i = 0; i < 8; i++) hash[i] = (hash[i] + oldHash[i]) | 0; }
    for (i = 0; i < 8; i++) for (j = 3; j + 1; j--) { var b = (hash[i] >> (j * 8)) & 255; result += ((b < 16) ? 0 : '') + b.toString(16); }
    return result;
  }

  function init() {
    resendPending();
    if (!resendPendingApplication()) sendApplicationIfConfirmed();
    if (path === '/pages/thanks') return;
    initSections(); initForms(); initCtas(); updateScroll();
    ['pointerdown', 'keydown', 'touchstart', 'scroll'].forEach(function (name) { document.addEventListener(name, touchInteraction, { passive: true, capture: true }); });
    window.addEventListener('scroll', function () { if (!scrollQueued) { scrollQueued = true; window.requestAnimationFrame(updateScroll); } }, { passive: true });
    window.setInterval(tickTime, 5000);
    document.addEventListener('visibilitychange', function () {
      tickTime();
      if (document.visibilityState === 'hidden') sendSnapshot('visibility_hidden', true);
      else { activeLastTick = performance.now(); lastInteraction = Date.now(); }
    });
    window.addEventListener('pagehide', function () { tickTime(); sendSnapshot('pagehide', true); }, { capture: true });
  }

  if (ENVIRONMENT === 'test') {
    window.HENGE_CLEAR_ANALYTICS_TEST = {
      getState: function () { return JSON.parse(JSON.stringify({ visitor_id: visitorId, session_id: sessionInfo.id, state: state, experiment: experimentContext, first_touch: readTouch(KEYS.first) || {}, last_touch: readTouch(KEYS.last) || {}, endpoint_configured: Boolean(endpoint) })); },
      snapshot: function () { return sendSnapshot('manual_test', false); },
      reset: function () { Object.keys(KEYS).forEach(function (k) { storageRemove(window.localStorage, KEYS[k]); storageRemove(window.sessionStorage, KEYS[k]); setCookie(KEYS[k], '', 0); }); }
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
